import { render, staticRenderFns } from "./categoryList.vue?vue&type=template&id=70284ece&scoped=true&"
import script from "./categoryList.vue?vue&type=script&lang=js&"
export * from "./categoryList.vue?vue&type=script&lang=js&"
import style0 from "./categoryList.vue?vue&type=style&index=0&id=70284ece&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70284ece",
  null
  
)

export default component.exports